import * as subjectMessage from "./subject-message";

export default [subjectMessage]



// WEBPACK FOOTER //
// ./src/store/modules/global-data-maintain/index.js